import { useState, useMemo, useEffect, useRef } from 'react';
import FilterTag from '@/components/filter-tag';
import TimestampRangePicker from '@/components/timestamp-RangePicker';
import { Select } from '@drip/drip-design';
// @ts-ignore
import { RadioGroup, RadioButtonGroup, Tooltip, Icon, Tag } from '@jd/jmtd';
import moment from 'moment';

const now_618 = moment().year() + '-06-18';
const now_1111 = moment().year() + '-11-11';

function TimeControl(props: any) {
  const { onChange } = props;
  const _onChange = useRef(onChange);
  const [dataType, setDataType] = useState<string>('REALTIME'); //real-time:实时，offline-time，离线
  // 查询开始结束时间
  const [date, setDate] = useState({
    beginDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  });
  const options = useMemo(() => {
    let _options = [
      {
        label: '自定义',
        value: '7',
      },
    ];
    if (moment().startOf('day') > moment(now_618)) {
      _options.push({
        label: '对比今年618',
        value: '1',
      });
    }
    if (moment().startOf('day') > moment(now_1111)) {
      _options.push({
        label: '对比今年双11',
        value: '2',
      });
    }
    _options.push(
      {
        label: '对比去年618',
        value: '3',
      },
      {
        label: '对比去年双11',
        value: '4',
      },
      {
        label: '同比',
        value: '5',
      },
      {
        label: '环比',
        value: '6',
      }
    );
    return _options;
  }, []);
  // 对比类型
  const [vsType, setVsType] = useState(options[0].value);
  // 对比时间
  const [vsDate, setVsDate] = useState({
    cBeginDate: '',
    cEndDate: '',
  });


  useEffect(() => {
    if (dataType == 'REALTIME') {
      setDate({
        beginDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      });
    } else {
      setDate({
        beginDate: moment().subtract(1, 'day').format('YYYY-MM-DD'),
        endDate: moment().subtract(1, 'day').format('YYYY-MM-DD'),
      });
    }
  }, [dataType]);

  useEffect(() => {
    if (!_onChange.current || !vsDate.cBeginDate) return;
    _onChange.current({ dataType, ...date, ...vsDate });
    // eslint-disable-next-line
  }, [vsDate]);

  useEffect(() => {
    const dataRange = moment(date.endDate).valueOf() - moment(date.beginDate).valueOf();
    switch (vsType) {
      case '1':
        setVsDate({
          cBeginDate: moment(moment(now_618).valueOf() - dataRange).format('YYYY-MM-DD'),
          cEndDate: now_618,
        });
        return;
      case '2':
        setVsDate({
          cBeginDate: moment(moment(now_1111).valueOf() - dataRange).format('YYYY-MM-DD'),
          cEndDate: now_1111,
        });
        return;
      case '3':
        setVsDate({
          cBeginDate: moment(moment(moment().year() - 1 + '-06-18').valueOf() - dataRange).format('YYYY-MM-DD'),
          cEndDate: moment().year() - 1 + '-06-18',
        });
        return;
      case '4':
        setVsDate({
          cBeginDate: moment(moment(moment().year() - 1 + '-11-11').valueOf() - dataRange).format('YYYY-MM-DD'),
          cEndDate: moment().year() - 1 + '-11-11',
        });
        return;
      case '5':
        setVsDate({
          cBeginDate: moment(moment(date.endDate).subtract(1, 'year').valueOf() - dataRange).format('YYYY-MM-DD'),
          cEndDate: moment(date.endDate).subtract(1, 'year').format('YYYY-MM-DD'),
        });
        return;
      case '6':
        setVsDate({
          cBeginDate: moment(moment(date.beginDate).subtract(1, 'day').valueOf() - dataRange).format('YYYY-MM-DD'),
          cEndDate: moment(date.beginDate).subtract(1, 'day').format('YYYY-MM-DD'),
        });
        return;
      case '7':
        setVsDate({
          cBeginDate: moment(date.beginDate).subtract(1, 'day').format('YYYY-MM-DD'),
          cEndDate: moment(moment(date.beginDate).subtract(1, 'day').valueOf() + dataRange).format('YYYY-MM-DD'),
        });
        return;
      default:
        return;
    }
  }, [vsType, date]);

  function handleDataTypeChange(val:any){
    setDataType(val);
    if(val == 'REALTIME'){
      props.handleLog && props.handleLog('3')
    }else {
      props.handleLog && props.handleLog('4')
    }
  }

  function handleDataVSTypeChange(val:any){
    setVsType(val);
    switch (val) {
      case '1':
        props.handleCustomLog && props.handleCustomLog(['yx_center', 'ComparisonTimeDetails', `{"comtype":"对比今年618"}`]);
        return;
      case '2':
        props.handleCustomLog && props.handleCustomLog(['yx_center', 'ComparisonTimeDetails', `{"comtype":"对比今年双11"}`]);
        return;
      case '3':
        props.handleCustomLog && props.handleCustomLog(['yx_center', 'ComparisonTimeDetails', `{"comtype":"对比去年618"}`]);
        return;
      case '4':
        props.handleCustomLog && props.handleCustomLog(['yx_center', 'ComparisonTimeDetails', `{"comtype":"对比去年双11"}`]);
        return;
      case '5':
        props.handleCustomLog && props.handleCustomLog(['yx_center', 'ComparisonTimeDetails', `{"comtype":"同比"}`]);
        return;
      case '6':
        props.handleCustomLog && props.handleCustomLog(['yx_center', 'ComparisonTimeDetails', `{"comtype":"环比"}`]);
        return;
      case '7':
        props.handleCustomLog && props.handleCustomLog(['yx_center', 'ComparisonTimeDetails', `{"comtype":"自定义"}`]);
        return;
      default:
        return;
    }
  }
  return (
    <span className="time-control-block">
      {/*<FilterTag.Group border={false} value={dataType} onChange={setDataType}>*/}
      {/*  <FilterTag value="REALTIME" key={1}>*/}
      {/*    今日*/}
      {/*  </FilterTag>*/}
      {/*  <FilterTag value="OFFLINE" key={2}>*/}
      {/*    离线*/}
      {/*  </FilterTag>*/}
      {/*</FilterTag.Group>*/}
      <RadioGroup
        className='time-radio'
        render={RadioButtonGroup}
        value={dataType}
        onChange={((val:any)=>{handleDataTypeChange(val)})}
        data={[{
          value: 'REALTIME',
          label: <>今日 <Tooltip title={'展示从今日0点至今的实时累计数据，最细粒度是10分钟粒度。'}>
            <Icon className='jmti-question-circle' ></Icon>
          </Tooltip></>
        },{
          value: 'OFFLINE',
          label: '离线'
        }]}
        outline
        size='small'
      />
      <RangePicker
        allowClear={false}
        disabled={dataType === 'REALTIME'}
        value={date}
        format="YYYY-MM-DD"
        fieldNames={{ start: 'beginDate', end: 'endDate' }}
        type={TimestampRangePicker.DATA_STRING}
        onChange={(val: any)=>{
          setDate(val);
          props.handleLog && props.handleLog('5')
        }}
      />
      <span className="vstime-label">对比时间</span>
      <Tag key={dataType} clsTag={dataType == 'REALTIME' ? 'h|keycount|yx_center_hzcp_1678258944439|14' : 'h|keycount|yx_center_hzcp_1678258944439|15'}>
        <Select value={vsType} onChange={(val:any)=>{handleDataVSTypeChange(val)}}>
          {options.map((item: any) => (
            <Select.Option value={item.value} key={item.value}>
              {item.label}
            </Select.Option>
          ))}
        </Select>
      </Tag>

      <RangePicker
        allowClear={false}
        disabled={vsType !== '7'}
        value={vsDate}
        format="YYYY-MM-DD"
        fieldNames={{ start: 'cBeginDate', end: 'cEndDate' }}
        type={TimestampRangePicker.DATA_STRING}
        onChange={(val: any)=>{
          setVsDate(val);
          props.handleLog && props.handleLog('6')
        }}
      />
    </span>
  );
}

export default TimeControl;

function RangePicker(props: any) {
  const { onChange, ...resProps } = props;
  const [dates, setDates] = useState(null);
  const [hackValue, setHackValue] = useState<boolean>(false);

  const disabledDate = (current: any) => {
    if (!dates) {
      return false;
    }
    // @ts-ignore
    const tooLate = dates[0] && current.diff(dates[0], 'days') >= 31;
    // @ts-ignore
    const tooEarly = dates[1] && dates[1].diff(current, 'days') >= 31;
    return tooEarly || tooLate;
  };

  const onOpenChange = (open: boolean) => {
    if (open) {
      setHackValue(true);
      setDates(null);
    } else {
      setHackValue(false);
    }
  };

  return (
    <TimestampRangePicker
      {...resProps}
      value={hackValue ? null : props.value}
      disabledDate={disabledDate}
      onCalendarChange={(val: any) => setDates(val)}
      onChange={onChange}
      onOpenChange={onOpenChange}
    />
  );
}
